import React, { useState } from "react"
import {
  Box,
  Button,
  RadioGroup,
  Radio,
  FormControlLabel,
  Typography,
  AppBar,
  Toolbar,
} from "@mui/material"
import { useNavigate } from "react-router-dom"
import { CansList } from "../../components/cans/CansList"
import { Heading } from "../../components/layout/Heading"

interface ListProps {
  provider?: string
  state?: string
  type?: string
  hasRgSurvey?:boolean
  cans: any[]
}

export const List = ({ provider, state, type, cans ,hasRgSurvey}: ListProps) => {

  const navigate = useNavigate()
  const questions = [
    "Have you ever set a betting limit before?",
    "Do you consider gambling as a source of income?",
    "Have you felt guilty after gambling?",
    "Do you chase losses after losing bets?",
    "Do you ever borrow money to gamble?",
    "Has gambling affected your relationships or work?",
    "Do you want help to gamble more responsibly?",
  ]

  const [activeStep, setActiveStep] = useState(0)
  const [answers, setAnswers] = useState(Array(7).fill(""))
  // const [content, setContent] = useState(false)
  // const [formContent, setformContent] = useState(true)
  const [content, setContent] = useState(!hasRgSurvey)
  const [formContent, setformContent] = useState(hasRgSurvey)
  
  const handleNext = () => {
    if (activeStep < questions.length - 1) {
      setActiveStep((prev) => prev + 1)
    }
  }

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep((prev) => prev - 1)
    }
  }

  const handleChange = (e:any) => {
    const updated = [...answers]
    updated[activeStep] = e.target.value
    setAnswers(updated)
  }

  const handleSubmit = () => {

    //  const q1 = answers[0]?.toLowerCase();
    //  const q2ToQ6 = answers.slice(1, 6).map((a) => a?.toLowerCase());
    //  const q7 = answers[6]?.toLowerCase();
    //  const hasRiskyAnswers = q2ToQ6.includes("yes");

    // const allow = q1 === "yes" && q7 === "yes" && !hasRiskyAnswers;

    // if (allow) {
    //   setContent(true)
    //   setformContent(false)
    // } else {
    //   navigate("/support")
    // }
    //console.log("answers ",answers)
    const hasYes = answers.some((ans) => ans === "yes")

    if (hasYes) {
      navigate("/support")
    } else {
      setContent(true)
      setformContent(false)
    }
  }

  return (
    <>
      {formContent && (
        <div className="stepForm mb-5">
          <Box
            sx={{
              maxWidth: 900,
              mx: "auto",
              mt: 4,
              p: 2,
              border: "1px solid #ddd",
              borderRadius: 2,
            }}
          >
            {activeStep == 0 && (
              <>
                <h4 className="main-heading"><span>Before You</span> Continue…</h4>
                <p>
                  At PlayCan, we believe gambling should always be fun, safe,
                  and positive.
                </p>
                <p>
                  Before we recommend any casino or sportsbook offers, we invite
                  you to complete a quick 7-part questionnaire about your past
                  experiences on betting sites.
                </p>
                <p>
                  It takes less than 30 seconds, and helps us better understand
                  gambling behaviours so we can support safer play — and improve
                  how responsible gambling is approached across the industry.
                </p>
                <p>
                  Please answer each question honestly. Your responses help
                  inform responsible gambling insights in North America.
                </p>
              </>
            )}

            <Typography variant="h4" gutterBottom>
              <b>Step {activeStep + 1} of 7</b>
            </Typography>

            <Typography variant="h6" sx={{ mb: 2 }}>
              <b>{questions[activeStep]}</b>
            </Typography>

            <RadioGroup value={answers[activeStep]} onChange={handleChange}>
              <FormControlLabel value="yes" control={<Radio />} label="Yes" />
              <FormControlLabel value="no" control={<Radio />} label="No" />
            </RadioGroup>

            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}
            >
              <Button
                variant="outlined"
                onClick={handleBack}
                disabled={activeStep === 0}
              >
                Back
              </Button>

              {activeStep === questions.length - 1 ? (
                <Button
                  variant="contained"
                  onClick={handleSubmit}
                  disabled={!answers[activeStep]}
                >
                  Submit & Continue
                </Button>
              ) : (
                <Button
                  variant="contained"
                  onClick={handleNext}
                  disabled={!answers[activeStep]}
                >
                  Next
                </Button>
              )}
            </Box>
          </Box>
        </div>
      )}

      {content && (
        <div className="casinoContent">
          <Heading type={type} state={state} />
          <div className="casino">
            <CansList
              type={type}
              state={state}
              cans={cans}
              provider={provider}
            />{" "}
            <div className="disclaimer mainDisclaimer">
              <p>
                <span>Affiliate Disclosure:</span> PlayCan may receive
                advertising commissions for visits to a sportsbook or casino
                betting site. 19+ Gambling can be addictive, please play
                responsibly.
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
